import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from "dayjs";
import errorIcon from "../../assets/icons/error-icon.svg";
import DateField from "../../shared/components/DateField";

const CustomDateRange = () => {
  const { control, getValues, watch, trigger } = useFormContext();

  const today = dayjs();
  const startDateValue = watch("startDate");
  const endDateValue = watch("endDate");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name="startDate"
        control={control}
        rules={{
          validate: (value) => {
            if (!value || !value.isValid()) {
              return "Invalid start date";
            }
            if (endDateValue && value.isAfter(endDateValue, "day")) {
              return "Start date cannot be later than end date";
            }
            if (value.isAfter(today, "day")) {
              return "Start date cannot be in the future";
            }
            return true;
          }
        }}
        render={({ field, fieldState: { error } }) => (
          <div className="col-md-6">
            <label className="filter-label" htmlFor="startDate">
              Start date
              <DateField
                {...field}
                value={field.value || null}
                disableFuture={true}
                maxDate={getValues("maxDate")}
                minDate={getValues("minDate")}
                format="MM/DD/YYYY"
                onChange={async (date) => {
                  field.onChange(date);
                  await trigger(["startDate", "endDate"], { shouldFocus: false });
                }}
                placeholder="Start date"
              />
            </label>
            {error?.message && (
              <div className="create-segment__input-wrap__segment-err">
                <img src={errorIcon} alt="Error Icon" />
                {error?.message}
              </div>
            )}
          </div>
        )}
      />
      <Controller
        name="endDate"
        control={control}
        rules={{
          validate: (value) => {
            if (!value || !value.isValid()) {
              return "Invalid end date";
            }
            if (startDateValue && value.startOf('day').isBefore(startDateValue.startOf('day'))) {
              return "End date cannot be earlier than start date";
            }
            if (value.isAfter(today, "day")) {
              return "End date cannot be in the future";
            }
            return true;
          }
        }}
        render={({ field, fieldState: { error } }) => (
          <div className="col-md-6">
            <label className="filter-label" htmlFor="endDate">
              End date
              <DateField
                {...field}
                disableFuture={true}
                value={field.value || null}
                maxDate={getValues("maxDate")}
                minDate={getValues("minDate")}
                format="MM/DD/YYYY"
                onChange={async (date) => {
                  field.onChange(date);
                  await trigger("startDate");
                }}
                placeholder="End date"
              />
            </label>
            {error?.message && (
              <div className="create-segment__input-wrap__segment-err">
                <img src={errorIcon} alt="Error Icon" />
                {error?.message}
              </div>
            )}
          </div>
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDateRange;
